import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

export function runApp() {
  const { store, httpApi, logger, microfrontendsRegistry, eventQueue } = createApplicationState();

  renderApplication({ store, httpApi, logger, microfrontendsRegistry, eventQueue });
}
